import styles from "./styles";
import React from "react";
import {Container, Typography, withStyles} from "@material-ui/core";



const ClaimListStatusLabel = (props) => {

    const { classes, claimStatuses } = props;

    return (
        <Container className={classes.container}>
            {claimStatuses.map((status, index) => {
                return (
                    <React.Fragment key={status.title}>
                        <Typography className={classes.title}>{status.title}</Typography>
                        <Typography className={classes.description}>{status.description}</Typography>
                    </React.Fragment>
                )
            })}
        </Container>
    )
}

export default withStyles(styles)(ClaimListStatusLabel);